/** @jsx h */
import { useEffect, useState } from 'preact/hooks';
import { labels } from '../../config';
import MapFilterCheckbox from './MapFilterCheckbox';

const FilterFieldset = ({ id, facet, triggerAjaxSubmit, pluginNamespace }) => {
  const [isOpen] = useState(false);
  /* eslint-disable no-unused-vars */
  const [isActive, setIsActive] = useState(false);
  /* eslint-enable no-unused-vars */

  function handleFilterCheckboxChange() {
    triggerAjaxSubmit();
  }

  useEffect(() => {
    const hasActiveFilter = element => element.selected;
    const hasActiveFilters = facet.options.some(hasActiveFilter);
    setIsActive(hasActiveFilters);
  }, [facet, isOpen]);

  return (
    <fieldset class="form__fieldset">
      <legend class="form__legend form__legend--small form__legend--centered form__legend--map">
        {labels.faceting.filterFor}:
      </legend>
      <ul class="input-filter-container input-filter-container--map">
        {facet.options.length
          ? facet.options.map(option => (
              <MapFilterCheckbox
                option={option}
                filterName={facet.name}
                handleChange={handleFilterCheckboxChange}
                pluginNamespace={pluginNamespace}
                key={option.value}
              />
            ))
          : ''}
      </ul>
    </fieldset>
  );
};

export default FilterFieldset;
